import * as React from 'react';
import { GridActionsCellItem } from '@mui/x-data-grid';
import DeleteIcon from '@mui/icons-material/Delete';

type Props = {
  id: any;
  onDelete: (id: any) => void;
  disabled?: boolean;
  label?: string;
};

export const FGridDeleteAction = ({ id, onDelete, disabled, label = 'Delete' }: Props) => (
  <GridActionsCellItem
    icon={<DeleteIcon />}
    label={label}
    disabled={disabled}
    onClick={() => onDelete(id)}
    showInMenu={false}
  />
);

export default FGridDeleteAction;
